import getAccessToken from "./auth/getAccessToken";

// The parts of public/config.js read here.
interface CarrotConfig {
  strive?: {
    host?: string;
    port?: number;
    secure?: boolean;
    pathPrefix?: string;
  };
}

export function getCarrotConfig(): CarrotConfig {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (window as any).Rune?.Carrot?.config ?? {};
}

// The Strive host, which serves Tangerine's /api/v3 endpoints.
export function getStriveBaseUrl(): string {
  const config = getCarrotConfig().strive;
  if (!config?.host) {
    throw new Error(
      "Strive API host not configured in window.Rune.Carrot.config.strive"
    );
  }
  const protocol = config.secure === false ? "http" : "https";
  const port = config.port ? `:${config.port}` : "";
  const pathPrefix = config.pathPrefix || "";
  return `${protocol}://${config.host}${port}${pathPrefix}`;
}

export async function striveHeaders(): Promise<Record<string, string>> {
  return {
    "X-Rune-User-Access-Token": await getAccessToken(),
    Accept: "application/json"
  };
}
